import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { kpiConstants, kpiModels } from '..';

export const useKpiConfigSave = () => {
  const qc = useQueryClient();

  return useMutation<any, any, kpiModels.IKpiConfig>(
    async data => {
      const res = await $api.post('/v1/kpi/config', data);

      return res?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries({ queryKey: [kpiConstants.queryKeys.KPI_CONFIG] });
      }
    }
  );
};
